import AccessRightControlPanel from "./AccessRightControlPanel.container";

export default AccessRightControlPanel;
